import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import TeacherLogin from "@/pages/TeacherLogin";
import TeacherDashboard from "@/pages/TeacherDashboard";
import CreateGame from "@/pages/CreateGame";
import TeacherLive from "@/pages/TeacherLive";
import StudentJoin from "@/pages/StudentJoin";
import StudentPlay from "@/pages/StudentPlay";
import GameReport from "@/pages/GameReport";
import AdminContent from "@/pages/AdminContent";
import TeacherGuide from "@/pages/TeacherGuide";
import IdiomShowcase from "@/pages/IdiomShowcase";
import { Toaster } from "sonner";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen dark bg-[#070B14] text-white flex items-center justify-center">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-center" theme="dark" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/rehber" element={<TeacherGuide />} />
            <Route path="/deyimler" element={<Protected><IdiomShowcase /></Protected>} />
            <Route path="/login" element={<TeacherLogin />} />
            <Route path="/join" element={<StudentJoin />} />
            <Route path="/play/:code" element={<StudentPlay />} />
            <Route path="/teacher" element={<Protected><TeacherDashboard /></Protected>} />
            <Route path="/teacher/create/:packKey" element={<Protected><CreateGame /></Protected>} />
            <Route path="/teacher/live/:code" element={<Protected><TeacherLive /></Protected>} />
            <Route path="/teacher/report/:gameId" element={<Protected><GameReport /></Protected>} />
            <Route path="/admin/content" element={<Protected><AdminContent /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
